import { Box, TagColor as Color, Tag } from '@factorialco/deprecated-design-system'
import { PerformanceReviewEvaluationQuery } from 'generated/resources/graphql'

type PerformanceReviewEvaluation = NonNullable<
  PerformanceReviewEvaluationQuery['performance']['reviewEvaluation']
>

import i18n from 'modules/core/lib/i18n'

interface Props {
  evaluations: Pick<PerformanceReviewEvaluation, 'status' | 'id'>[]
}

export const PeerEvaluationsStats = ({ evaluations }: Props) => {
  const publishedEvaluations = evaluations.filter((evaluation) => evaluation.status === 'published')
  if (publishedEvaluations.length === evaluations.length) {
    return (
      <Box>
        <Tag inline capitalize type={Color.correct}>
          {i18n.t('performance_process.reviews.target_datatable.peer_review.done')}
        </Tag>
      </Box>
    )
  } else {
    return (
      <Box>
        <Tag inline capitalize type={Color.champagne}>
          {i18n.t('performance_process.reviews.target_datatable.peer_review.in_progress', {
            progress: `${publishedEvaluations.length}/${evaluations.length}`,
          })}
        </Tag>
      </Box>
    )
  }
}
